module.exports = __webpack_public_path__ + "static/media/img-configurazione-email-automatica.a0578172.jpg";